import { Suspense } from "react";

import type { ReactNode } from "react";
import { useInView } from "react-intersection-observer";
export const LazySection = ({
  className,
  children,
  fallback,
}: {
  className: string;
  children: ReactNode;
  fallback?: ReactNode;
}) => {
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: "200px" });
  return (
    <div ref={ref} className={className}>
      <Suspense
        fallback={fallback || <div style={{ minHeight: 100, width: "100%" }} />}
      >
        {inView
          ? children
          : fallback || <div style={{ minHeight: 100, width: "100%" }} />}
      </Suspense>
    </div>
  );
};

export const LazySectionEx = ({
  className,
  children,
  fallback,
}: {
  className: string;
  children: ReactNode;
  fallback?: ReactNode;
}) => {
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: "200px" });
  return (
    <Suspense
      fallback={fallback || <div style={{ minHeight: 100, width: "100%" }} />}
    >
      {inView ? (
        children
      ) : (
        <>
          <div ref={ref} className={className}></div>
          {fallback || <div style={{ minHeight: 100, width: "100%" }} />}
        </>
      )}
    </Suspense>
  );
};
